// The version of the whole game: rules, look and words together. Bump it,
// and add an entry to src/config/history.ts, whenever anything in
// src/config/ changes; tests/unit/config.test.ts refuses to pass until both
// are done. Semantic: major = a save or a rite can no longer be read the old
// way (never done without a migration), minor = a new feature or a changed
// look, patch = a fix that changes no choice.
export const GAME_VERSION = "0.17.2"
